import React, { useEffect,useState } from "react";
import unsplash from "../api/unsplash";
import { useNavigate } from "react-router-dom";
import { CSpinner } from "@coreui/react";
import {Box,IconButton,Dialog,DialogTitle,DialogContent,Alert,Button,TextField,DialogActions,Select,OutlinedInput,MenuItem,FormControl,Card,Grid,CardContent} from '@mui/material';
import { DataGrid, GridToolbar, itIT } from '@mui/x-data-grid';
import {Add, Circle} from "@mui/icons-material";
import GlobalSnackbar from "./Snackbar";



const columns = [    {     
    field: 'Cognome',
    headerName: 'Cognome',
    //width: 400,
    flex:1,
    headerAlign: 'center',
    align: 'center',
    sort: 'asc'
  },
  { field: 'Nome',
  headerName: 'Nome',
  //width: 300,
  flex:1,
  headerAlign: 'center',
  align: 'center',
  sort: 'asc' 
  },
  { field: 'CF',
  headerName: 'Codice Fiscale',
  //width: 300,
  flex:1,
  headerAlign: 'center',
  align: 'center',
  sort: 'asc'
  },{ field: 'DataDiNascita',
  headerName: 'Data di Nascita',
  //width: 300,
  flex:1,
  headerAlign: 'center',
  align: 'center',
  sort: 'asc'
  },
  ,{ field: 'email',
  headerName: 'Email',
  //width: 300,
  flex:1,
  headerAlign: 'center',
  align: 'center',
  sort: 'asc'
  }

]



const Medici = () => {
const [medici,setMedici] = useState([]);
const [mediciVisibili,setMediciVisibili] = useState([]);
const navigate = useNavigate();


const handleChange = (e) => { // filtro
 


    if(e.target.value == ""){
        setMediciVisibili(medici);
    
   }else{
     var mediciX = []; // popolo l'array 
   var i;
   for (i =0 ;i < medici.length;i++){
     if (medici[i].RagioneSociale.toLowerCase().includes((e.target.value.toLowerCase() ))){
        mediciX.push(medici[i]);
     }
   }
   setMediciVisibili(mediciX);
   }
 
   }






useEffect(() => {// è un loop qui carico i dati 
    const fetchData = async () =>{

      try {
    
                  let response = await  unsplash.get('medici', {headers: {
                    'Authorization': `Bearer ${localStorage.getItem('jwt')}`}
                });
                setMedici(response.data.data)
                setMediciVisibili(response.data.data)
                                
      } catch (error) {
        console.error(error.message);
      }
      
    }

    fetchData();
   
  }, []);



    return (

        <>  {/*<GlobalSnackbar severity={snack.severity} messaggio={snack.messaggio} openSnack={openSnack} handleCloseSnack={handleCloseSnack}/>*/}
        <Grid item xs={12}>
      
      <Card>
        <CardContent>
      <div>
      <div ><center >
      
      <div className="form-outline mb-4 input-group" style={{width:"33%"}}>
      <span class="input-group-text bg-transparent">
                  <i class="bi bi-search" ></i>
                  </span>
      <input onChange={handleChange} className="form-control form-control-lg border-left-0"/>
           
                 
                </div>
        
        
        
       </center></div>
      {
      
            mediciVisibili === undefined ? (<p> <center><CSpinner color="primary"/></center></p>):(
            <>
         
            <Box
            sx={{
                height: 700,
                width: 1
            }}
            >
        <DataGrid sx={{fontSize:12}}
                                      components={{ Toolbar: GridToolbar }}
                                      localeText={itIT.components.MuiDataGrid.defaultProps.localeText}
                                      rows={mediciVisibili}
                                      columns={columns}
                                      getRowId={(row) => row.ID}
                                      pageSize={20}
                                      initialState={{
                                          sorting: {
                                            sortModel: [{ field: 'Cognome', sort: 'ASC' }],
                                          },
                                        }}
                                  
                                      disableSelectionOnClick
                                      onRowClick={ async (params,event)=> 
                                          {
                                           
                                            
                                            navigate('/dettaglioMedico',{state:{medico:params.row}})
                                     
                                          }    
                                      }
                                      />
              </Box>
              </>


)
    

}


</div>
</CardContent>
</Card>
</Grid>

</>

    )
}

export default Medici;